














































































































































































































import Vue from 'vue'
import moment from 'moment'
import { Employee } from '@/model/companyStructure/Employee'
import { GET_CURRENT_USER_ID, GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import { AddressEmployee } from '@/model/addresses/AddressEmployee'
import {
  DELETE_NOTE_ATTACHMENT,
  FETCH_NOTE_ATTACHMENT_LIST,
  SAVE_NOTE,
  SAVE_NOTE_ATTACHMENT
} from '@/store/action-types'
import { NoteType } from '@/model/addresses/NoteType'
import _ from 'lodash'
import { Note } from '@/model/addresses/Note'
import { TranslateResult } from 'vue-i18n'
import { SnackbarStateEnum } from '@/types/enums'
import { NotePayload, SaveNoteAttachmentPayload } from '@/types/payload'
import {
  AdressenNotizenIndexResponse,
  DeleteNoteAttachmentResponse,
  GetNoteAttachmentListResponse,
  SaveNoteAttachmentResponse
} from '@/types/service-response'
import ImageGalleryDialog from '@/components/master-data/address/ImageGalleryDialog.vue'
import { SearchAddressEmployee } from '@/model/addresses/SearchAddressEmployee'
import { ResponsibleEmployee } from '@/model/addresses/ResponsibleEmployee'

interface EventFile extends Event {
  target: HTMLInputElement & EventTarget
}

interface AddressEmployeeWithFullName {
  id: number | undefined
  fullName: string
}

interface ComponentData {
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  inSaveProgress: boolean

  title: string
  validationRules: Array<Function>
  selectedAddressEmployee: number | undefined
  selectedResponsibleEmployee: number | undefined
  selectedAddressResponsibleEmployee: number | undefined
  menu1: boolean
  menu2: boolean
  dateStartIso: string | null
  dateStartFormatted: string | null
  dateEndIso: string | null
  dateEndFormatted: string | null
  alreadyDone: number
  selectedAuthor: number | undefined
  isPrivate: boolean
  noteType: number | undefined
  noteTitle: string
  noteText: string
  showImageGallery: boolean
  imageList: string[]
  imageIdList: number[]
  deleteLoading: boolean
  dateRules: Function[]
  numberOfStars: number | null
  isStar1Disabled: boolean
  isStar2Disabled: boolean
  isStar3Disabled: boolean
  isStar4Disabled: boolean
  isStar5Disabled: boolean
}

export default Vue.extend({
  name: 'NotesDialog',

  components: {
    ImageGalleryDialog
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },
    adressLinie: String,
    addressEmployee: Array as () => Array<AddressEmployee>,
    searchAddressEmployee: Array as () => Array<SearchAddressEmployee>,
    employeeList: Array as () => Array<Employee>,
    notesData: Object as () => Note,
    noteTypeList: Array as () => Array<NoteType>,
    addressId: Number,
    responsibleEmployeeList: Array as () => Array<ResponsibleEmployee>
  },

  data (): ComponentData {
    const required = (value: any): boolean | string => !!value || this.$t('masterData.addresses.required').toString()

    return {
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      inSaveProgress: false,

      title: '',
      validationRules: [required],
      selectedAddressEmployee: undefined,
      selectedResponsibleEmployee: undefined,
      selectedAddressResponsibleEmployee: undefined,
      menu1: false,
      menu2: false,
      dateStartIso: null,
      dateStartFormatted: '',
      dateEndIso: null,
      dateEndFormatted: '',
      alreadyDone: 0,
      selectedAuthor: undefined,
      isPrivate: false,
      noteType: undefined,
      noteTitle: '',
      noteText: '',
      showImageGallery: false,
      imageList: [],
      imageIdList: [],
      deleteLoading: false,
      dateRules: [
        (value: string) => {
          const pattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
          return value ? value.length >= 1 ? pattern.test(value) || this.$t('errors.wrongDate').toString() : true : true
        },

        (value: string) => {
          return !!value
        },

        () => {
          //@ts-ignore
          return this.isDatesValid
        }
      ],
      numberOfStars: null,
      isStar1Disabled: true,
      isStar2Disabled: true,
      isStar3Disabled: true,
      isStar4Disabled: true,
      isStar5Disabled: true,
    }
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    currentUserId (): number {
      return this.$store.getters[GET_CURRENT_USER_ID]
    },

    selectedLocale (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    addressEmployeeList (): AddressEmployeeWithFullName[] {
      if(this.addressEmployee && this.addressEmployee.length !== 0) {
        return this.addressEmployee.map((item: AddressEmployee) => {
          return { id: item.id, fullName: `${item.firstName} ${item.name}` }
        })
      } else if(this.searchAddressEmployee && this.searchAddressEmployee.length !== 0) {
        return this.searchAddressEmployee.map((item: SearchAddressEmployee) => {
          return { id: item.sachbearbeiterID, fullName: `${item.sachbearbeiterVorname} ${item.sachbearbeiterName}` }
        })
      } else {
        return []
      }
    },

    isDatesValid (): boolean {
      if(this.dateStartIso && moment(this.dateStartIso, 'YYYY-MM-DD').isValid() && this.dateEndIso && moment(this.dateEndIso, 'YYYY-MM-DD').isValid()) {
        return this.dateEndIso && moment(this.dateEndIso, 'YYYY-MM-DD').isBefore(moment(this.dateStartIso, 'YYYY-MM-DD')) ? false : true

      } else {
        return true
      }
    },

    stars (): number {
      return 5
    }
  },

  watch: {
    dateStartFormatted (newVal: string | null): void {
      if(newVal) {
        this.dateStartIso = moment(newVal, 'DD.MM.YYYY').isValid() ? moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD') : ''
      } else {
        this.dateStartIso = ''
      }
    },

    dateEndFormatted (newVal: string | null): void {
      if(newVal) {
        this.dateEndIso = moment(newVal, 'DD.MM.YYYY').isValid() ? moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD') : ''
      } else {
        this.dateEndIso = ''
      }
    },
  },

  methods: {
    onResetButtonClick (): void {
      this.resetStars()
    },
    resetStars (): void {
      this.isStar1Disabled = true
      this.isStar2Disabled = true
      this.isStar3Disabled = true
      this.isStar4Disabled = true
      this.isStar5Disabled = true
      this.numberOfStars = null
    },
    star1 (): void {
      this.isStar1Disabled = false
      this.isStar2Disabled = true
      this.isStar3Disabled = true
      this.isStar4Disabled = true
      this.isStar5Disabled = true
      this.numberOfStars = 1
    },
    star2 (): void {
      this.isStar1Disabled = false
      this.isStar2Disabled = false
      this.isStar3Disabled = true
      this.isStar4Disabled = true
      this.isStar5Disabled = true
      this.numberOfStars = 2
    },
    star3 (): void {
      this.isStar1Disabled = false
      this.isStar2Disabled = false
      this.isStar3Disabled = false
      this.isStar4Disabled = true
      this.isStar5Disabled = true
      this.numberOfStars = 3
    },
    star4 (): void {
      this.isStar1Disabled = false
      this.isStar2Disabled = false
      this.isStar3Disabled = false
      this.isStar4Disabled = false
      this.isStar5Disabled = true
      this.numberOfStars = 4
    },
    star5 (): void {
      this.isStar1Disabled = false
      this.isStar2Disabled = false
      this.isStar3Disabled = false
      this.isStar4Disabled = false
      this.isStar5Disabled = false
      this.numberOfStars = 5
    },

    onBlurStartDate (): void {
      this.dateStartFormatted = this.dateStartIso && moment(this.dateStartIso).isValid() ? moment(this.dateStartIso).format('DD.MM.YYYY') : ''
      setTimeout(() => {
        if(this.menu1) {
          this.menu1 = false
        }
      }, 100)
    },

    onBlurEndDate (): void {
      this.dateEndFormatted = this.dateEndIso && moment(this.dateEndIso).isValid() ? moment(this.dateEndIso).format('DD.MM.YYYY') : ''
      setTimeout(() => {
        if(this.menu2) {
          this.menu2 = false
        }
      }, 100)
    },

    onDateStartIsoChange (date: string): void {
      this.dateStartFormatted = moment(date).format('DD.MM.YYYY')
    },

    onDateEndIsoChange (date: string): void {
      this.dateEndFormatted = moment(date).format('DD.MM.YYYY')
    },

    onAddImageClick (): void {
      //@ts-ignore
      this.$refs.fileInput.click()
    },

    onFileChange (e: EventFile): void {
      if (e && e.target.files) {
        const files: File | undefined = e.target.files[0]

        if (files) {
          const reader = new FileReader()

          reader.readAsDataURL(files)
          reader.onload = (e: any) => {
            if (e.target && e.target.result) {
              if(this.notesData && this.notesData.id) {
                let type: string = e.target.result.split('/')[1].split(';')[0]
                let image = e.target.result.split(',')[1]

                const payload: SaveNoteAttachmentPayload = {
                  NoteId: this.notesData.id!,
                  File: image,
                  FileExtension: type
                }

                this.saveNoteAttachment(payload)
              } else {
                this.imageList.push(e.target.result)
              }

              /*const img = new Image()
              // @ts-ignore
              img.src = e.target.result
              img.onload = () => {
                const elem = document.createElement('canvas')
                /*const scaleFactor = 200 / img.width
                elem.width = 200
                elem.height = img.height * scaleFactor*/
                /*elem.width = img.width
                elem.height = img.height
                const ctx = elem.getContext('2d')

                //ctx!.drawImage(img, 0, 0, 200, img.height * scaleFactor)
                ctx!.drawImage(img, 0, 0, img.width, img.height)
                ctx!.canvas.toBlob((blob: any) => {
                  new File([blob], 'image', {
                    //type: 'image/png',
                    lastModified: Date.now()
                  })
                }, 'image/jpeg', 1)
                this.imageList.push(elem.toDataURL('image/jpeg', 1))
              }*/
            }
          }
        }
      }
    },

    onShowImageClick (): void {
      this.showImageGallery = true
    },

    onCloseImageGalleryDialog (): void {
      this.showImageGallery = false
      setTimeout(() => {
        const galleryButton: any = this.$refs['galleryButton']
        if (galleryButton) {
          galleryButton.$el.focus()
        }
      }, 0)
    },

    onCloseButtonClick (): void {
      this.$emit('close')
    },

    onCancelButtonClick (): void {
      this.$emit('close')
    },

    onDeleteFromImageList (item: number): void {
      this.imageList.splice(item, 1)
      if(this.imageList.length === 0) {
        this.showImageGallery = false
        setTimeout(() => {
          const typeField: any = this.$refs['typeField']
          if (typeField) {
            typeField.focus()
          }
        }, 0)
      }
    },

    async onDeleteFromImageIdList (item: number): Promise<void> {
      const imageNumber: number = this.imageIdList[item]

      try {
        this.deleteLoading = true
        let response: DeleteNoteAttachmentResponse = await this.$store.dispatch(DELETE_NOTE_ATTACHMENT, imageNumber)
        this.deleteLoading = false
        if(!response.IsError && response.Deleted) {
          this.imageIdList.splice(item, 1)
          if(this.imageList.length === 0) {
            this.onCloseImageGalleryDialog()
          }
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeDeleted')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.deleteLoading = false
        this.messageSnackbar = this.$t('errors.dataCouldNotBeDeleted')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    onSaveButtonClick (): void {
      const form: any = this.$refs['form']
      if (form.validate()) {

        const addressEmployee: AddressEmployeeWithFullName | undefined = this.addressEmployeeList.find((employee: AddressEmployeeWithFullName) => employee.id === this.selectedAddressEmployee)

        const payload: NotePayload = {
          id: this.notesData ? this.notesData.id ? this.notesData.id : null : null,
          selectedAddressEmployeeId: this.selectedAddressEmployee ? this.selectedAddressEmployee : null,
          selectedAddressEmployeeName: addressEmployee ? addressEmployee.fullName : null,
          selectedResponsibleEmployee:  this.selectedResponsibleEmployee ? this.selectedResponsibleEmployee : null,
          quality:  this.numberOfStars,
          selectedAddressResponsibleEmployee:  this.selectedAddressResponsibleEmployee ? this.selectedAddressResponsibleEmployee : null,
          dateStartIso:  this.dateStartIso!,
          dateEndIso:  this.dateEndIso!,
          alreadyDone:  this.alreadyDone,
          selectedAuthor:  this.selectedAuthor ? this.selectedAuthor : null,
          isPrivate:  this.isPrivate,
          noteType:  this.noteType ? this.noteType : null,
          noteTitle:  this.noteTitle,
          noteText:  this.noteText,
          addressId: this.addressId,
          action: this.notesData ? this.notesData.id ? 'Update ' : 'Insert' : 'Insert'
        }

        this.saveNote(payload)

      }
    },

    async saveNote (payload: NotePayload): Promise<void> {
      this.inSaveProgress = true
      try {
        let response: AdressenNotizenIndexResponse = await this.$store.dispatch(SAVE_NOTE, payload)
        if(!response.IsError && response.NoteId) {
          this.messageSnackbar = this.$t('success.dataHaveBeenSaved')
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
          this.imageList.forEach((item: string) => {
            let type: string = item.split('/')[1].split(';')[0]
            let image = item.split(',')[1]

            const payload: SaveNoteAttachmentPayload = {
              NoteId: response.NoteId,
              File: image,
              FileExtension: type
            }
            this.saveNoteAttachment(payload)
          })
          this.$emit('dialogSaved')
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      } finally {
        this.inSaveProgress = false
      }
    },

    async fetchNoteAttachmentList (): Promise<void> {
      try {
        let response: GetNoteAttachmentListResponse = await this.$store.dispatch(FETCH_NOTE_ATTACHMENT_LIST, this.notesData.id)
        if(!response.IsError) {
          if(response.Data) {
            this.imageIdList = response.Data
          }
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async saveNoteAttachment (payload: SaveNoteAttachmentPayload): Promise<void> {
      try {
        let response: SaveNoteAttachmentResponse = await this.$store.dispatch(SAVE_NOTE_ATTACHMENT, payload)
        if(!response.IsError && response.AttachmentId) {
          this.imageIdList.push(response.AttachmentId)
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    setQuality (): void {
      switch (this.numberOfStars) {
        case null:
          this.resetStars()
          break
        case 1:
          this.star1()
          break
        case 2:
          this.star2()
          break
        case 3:
          this.star3()
          break
        case 4:
          this.star4()
          break
        case 5:
          this.star5()
          break
      }
    }
  },

  mounted (): void {
    if(this.notesData && this.notesData.id) {
      this.title = this.$t('masterData.addresses.editNote').toString()
      const noteData: Note = _.cloneDeep(this.notesData)

      this.selectedAddressEmployee = noteData.addressEmployeeId
      this.selectedResponsibleEmployee = noteData.responsibleEmployee
      this.selectedAddressResponsibleEmployee = noteData.addressResponsibleEmployee
      this.numberOfStars = noteData.quality
      this.dateStartIso = moment(noteData.dateStartIso, "DD.MM.YYYY HH:mm:ss").format('YYYY-MM-DD')
      this.dateStartFormatted = this.dateStartIso.length > 0 ? this.dateStartIso = moment(this.dateStartIso).format('DD.MM.YYYY') : ''
      this.dateEndIso = moment(noteData.dateEndIso, "DD.MM.YYYY HH:mm:ss").format('YYYY-MM-DD')
      this.dateEndFormatted = this.dateEndIso.length > 0 ? this.dateEndIso = moment(this.dateEndIso).format('DD.MM.YYYY') : ''
      this.alreadyDone = noteData.alreadyDone
      this.selectedAuthor = noteData.author
      this.isPrivate = noteData.isPrivate
      this.noteType = noteData.noteType
      this.noteTitle = noteData.noteTitle
      this.noteText = noteData.noteText

      this.setQuality()
      this.fetchNoteAttachmentList()

    } else {
      this.title = this.$t('masterData.addresses.addNote').toString()
      this.selectedResponsibleEmployee = this.currentUserId
      this.selectedAuthor = this.currentUserId
      this.dateStartIso = moment().format('YYYY-MM-DD')
      this.dateStartFormatted = moment(this.dateStartIso).format('DD.MM.YYYY')
      this.dateEndIso = moment().format('YYYY-MM-DD')
      this.dateEndFormatted = moment(this.dateEndIso).format('DD.MM.YYYY')
      if(this.responsibleEmployeeList) {
        const foundEmployee: ResponsibleEmployee | undefined = this.responsibleEmployeeList.find((item: ResponsibleEmployee) => item.farben.length > 0)
        if(foundEmployee && foundEmployee.farben[0].AdressVerantwortungConfig && foundEmployee.farben[0].AdressVerantwortungConfig === foundEmployee.functionId) {
          this.selectedAddressResponsibleEmployee = foundEmployee ? foundEmployee.employeeId : undefined
        }
      }
    }

    setTimeout(() => {
      const focusedField: any = this.$refs['focusedField']
      if (focusedField) {
        focusedField.focus()
      }
    }, 0)
  }
})
